module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"not-recorded-yet":"Noch nicht erfasst","not-recorded":"nicht erfasst","operator-address":"Anlagenbetreiber"},"fr":{"not-recorded":"pas saisi","not-recorded-yet":"Pas encore saisi","operator-address":"Exploitant d’installations"},"it":{"not-recorded":"non registrato","not-recorded-yet":"Non ancora registrato","operator-address":"Operatore dell\u0027impianto"}}')
  delete Component.options._Ctor
}
